import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import * as Quill from 'quill';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { InfoTooltip } from 'app/modules/models/infoTooltip.type';

@Component({
  selector: 'app-info-tooltip-viewer',
  templateUrl: './info-tooltip-viewer.component.html',
  styleUrls: ['./info-tooltip-viewer.component.scss']
})
export class InfoTooltipViewerComponent implements OnInit {
  info : InfoTooltip;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }
  @ViewChild('editor') editorDiv!: ElementRef;
  ngOnInit(): void {
  this.info = this.data.info;
  this.createQuill();  
  }
  createQuill(){
    setTimeout(() => {
      const options = {
          readOnly: true,
          modules: {
            toolbar: null
          },
          theme: 'bubble'
        };
        const quill = new Quill('#editor', options);

      quill.setContents(JSON.parse(this.info.content));           
  }, 50);
  }
}